
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import { AWSFileService } from "@/services/aws-file-service";
import Vue from "vue";
import { AwsDocument } from "@/models/base/aws-document";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { AWSFile } from "@/models/aws-file";
import AppPreview from "@/components/documents/Preview.vue";
import { BrowserInfo } from "@/utils/browser";

export default Vue.extend({
	data(){
		return {
			showPreview: false,
			previewFile: {} as AWSFile,
			openingPreviewFiles: [] as AwsDocument[]
		};
	},
	props: {
		files: {
			type: Array as ()=>AwsDocument[],
			required: true
		},
		hideIfNoModule: Boolean
	},
	computed: {
		isAllowed():boolean {
			return AuthService.hasModule(this.moduleId);
		},
		moduleId():number {
			return MODULE.DOCUMENTENBEHEER;
		},
		showMissingModule():boolean {
			return !this.isAllowed && !this.hideIfNoModule;
		}
	},
	methods: {
		async openPreview(file: AwsDocument){
			let index = this.openingPreviewFiles.indexOf(file);
			if (index != -1) return;
			this.openingPreviewFiles.push(file);
			try{
				if (!file.File) return;
				if (BrowserInfo.isElectron()){
					this.previewFile = file.File;
					this.showPreview = true;
					return;
				}
				let f = file.File;
				if (!file) return;
				let blob = await AWSFileService.fetchFile(f.Token, f.Name, f.ContentType);
				let w = window.open("", "_blank");
				if (!w) return console.log("No window");
				if (!w) return console.log("No window");
				let url = URL.createObjectURL(blob);
				w.location = url;
				setTimeout(()=>URL.revokeObjectURL(url), 1000);
			}catch(err){
			}finally{
				index = this.openingPreviewFiles.indexOf(file);
				this.openingPreviewFiles.splice(index,1);
			}
		},
		isOpeningPreview(file:AwsDocument):boolean{
			return this.openingPreviewFiles.indexOf(file) != -1;
		},
		async download(file:AwsDocument){
			if (!file.File) return;
			await AWSFileService.downloadFile(file.File.Token, file.File.Name);
		}
	},
	components: {
		AppMissingModule,
		AppPreview
	}
});
